import React, { useEffect } from 'react';
import { MdDashboard } from 'react-icons/md';
import { SiAwsorganizations } from 'react-icons/si';
import { RiUserSettingsLine } from 'react-icons/ri';
import { GoQuestion } from 'react-icons/go';
import { Link, useLocation } from 'react-router-dom';
import procedures from '../../assets/Icons/Procedure.png';
import { RiFlowChart } from 'react-icons/ri';
import img from '../../assets/OHM_1.png';
import { shallowEqual, useSelector } from 'react-redux';
const Sidebar = ({ isDashboardClick }) => {
  const location = useLocation();
  // console.log(location)
  const { isOrgAuth, user } = useSelector(
    state => ({
      isOrgAuth: state.Organization.isOrgAuth,
      user: state.User.user,
    }),
    shallowEqual
  );
  let sidebar = [
    {
      Icon: MdDashboard,
      name: 'Dashboard',
      Link: Link,
      to: '/dashboard',
      img: false,
      isActive: location.pathname == '/dashboard' ? '#000000' : '#bdbdbd',
      showTo: 'admin',
    },
    // {
    //   Icon: MdDashboard,
    //   name: "Dashboard",
    //   Link: Link,
    //   to: "/user-dashboard",
    //   img: false,
    // },
    {
      Icon: RiFlowChart,
      name: 'Procedure',
      Link: Link,
      to: '/procedures',
      img: false,
      isActive: location.pathname === '/procedures' ? '#000000' : '#bdbdbd',
    },
    {
      Icon: SiAwsorganizations,
      name: 'Organization',
      Link: Link,
      to: '/organization',
      img: false,
      isActive: location.pathname == '/organization' ? '#000000' : '#bdbdbd',
      showTo: 'admin',
    },
    {
      Icon: RiUserSettingsLine,
      name: 'Users',
      Link: Link,
      to: '/user',
      img: false,
      isActive: location.pathname == '/user' ? '#000000' : '#bdbdbd',
      showTo: 'admin',
    },
    // {
    //   Icon: RiUserSettingsLine,
    //   name: "Previlledges",
    //   Link: Link,
    //   to: "/previlledges",
    //   img: false,
    // },
    {
      Icon: RiUserSettingsLine,
      name: 'Role Manage',
      Link: Link,
      to: '/role-manage',
      img: false,
      isActive: location.pathname == '/role-manage' ? '#000000' : '#bdbdbd',
      showTo: 'admin',
    },
  ];
  sidebar = sidebar.filter(
    item => item.showTo !== 'admin' || user?.role?.includes('admin')
  );
  return (
    <div className="w-[12vw] h-[100%]  bg-white rounded-xl">
      <div className="w-[100%] h-[8vh] bg-[#fe104d] rounded-t-xl flex justify-center items-center">
        <img src={img} className="w-[10dvw] h-[5dvh] object-fill" alt="" />
      </div>
      <div className="w-[100%] h-[89dvh] flex flex-col mt-5 ">
        <div className="w-[100%] h-[50%] flex flex-col gap-3">
          {sidebar.map(({ Icon, img, name, Link, to, isActive }, index) =>
            (name == 'Role Manage' && user.role == 'user') ||
            (name == 'Users' && user.role == 'user') ? (
              <>
                {/* <Link to={to}>
          <div
            key={index}
            className="w-[100%] min-h-[8vh] flex flex-col justify-center items-center"
          >
            <img
              src={Icon}
              className="w-[30px] h-[30px] object-fill"
              alt=""
            />
            <p className="text-[#bdbdbd]">{name}</p>
          </div>
        </Link> */}
              </>
            ) : img ? (
              <Link to={to}>
                <div
                  key={index}
                  className="w-[100%] min-h-[8vh] flex flex-col justify-center items-center"
                >
                  {/* <Icon color={`${isActive}`} fontSize={"30px"} />
                   <p style={{color:`${isActive}`}}>{name}</p> */}
                  <img
                    src={Icon}
                    className="w-[25px] h-[25px] object-fill "
                    alt=""
                  />
                  <p className="text-[#bdbdbd]">{name}</p>
                </div>
              </Link>
            ) : (
              <Link to={to}>
                <div
                  key={index}
                  className="w-[100%] min-h-[8vh] flex flex-col justify-center items-center"
                >
                  <Icon color={`${isActive}`} fontSize={'20px'} />
                  <p style={{ fontSize: '15px', color: `${isActive}` }}>
                    {name}
                  </p>
                </div>
              </Link>
            )
          )}
        </div>
        <div className="w-[100%] h-[50%] flex items-end mb-8 ">
          <div className="w-[100%] min-h-[8vh] flex flex-col justify-center items-center">
            <Link to="/dashboard">
              <GoQuestion color="#bdbdbd" fontSize={'30px'} />
              <p className="text-[#bdbdbd]">Help</p>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
